import * as d3 from "d3";
import { useState, useEffect, useRef, useContext } from "react";
import { useTranslation } from 'react-i18next';
import { GraphContext } from "../../GraphContext";
import { preferences } from "../../../preferences";
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import { setup } from '../../../components/d3/charts/genchart.js';
import { xlabel, ylabel, logo } from '../../../components/d3/charts/chart.js';
import { } from '../brushX.js';

import SensorButton from "../../../components/SensorButton.js";
import GraphicButton from '../../../components/GraphicButton';

export default function Tempchart ( ) {

	const { t, i18n } = useTranslation();

    const svgRef = useRef();

	const [ data, setData ] = useState([]);
	const [ ready, setReady ] = useState(false);

	const [ parameter, setParameter ] = useContext(GraphContext);
	const [ sensors, setSensors ] = useState ([]);

	const getWidth = () => window.innerWidth 
	  	|| document.documentElement.clientWidth 
  		|| document.body.clientWidth;

	const [resize, setResize] = useState(getWidth());

	const resizeHandler = (() => {
		var r = getWidth();
	    setResize(r);
	});

	window.addEventListener('resize', resizeHandler);

	function draw (data) {
		let svg = d3.select(svgRef.current);

		setup (svg, data, sensors, parameter.level, 20, 50, 60, 20, t);
		
		let w = svg.attr("width");
		let h = svg.attr("height");
		data !== undefined && xlabel (svg, t("date"), w/2, h-5);
		logo (svg);
	}

	useEffect (() => {
		let query = preferences.address+"/query/charts/valuesTemp.php?station="+parameter.station+"&from="+parameter.from+"&to="+parameter.to+"&level="+parameter.level;
		
		d3.json(query)
			.then ((data) => {
				data.timeline.map((d, i) => {
						d = d3.timeParse("%Y-%m-%d %H:%M:%S")(d);	
			    });
			    data.minTime= d3.timeParse("%Y-%m-%d %H:%M:%S")(data.minTime);
			    data.maxTime= d3.timeParse("%Y-%m-%d %H:%M:%S")(data.maxTime);
			    setData(data);
			    data.sensors.map((item) => {
				    var s = sensors.filter(obj => {return obj.cat === item.cat})
				    if (s.length > 0 ) item.active = s[0].active; else item.active=true;
			    })
			    if (data.sensors.length > 0)
			    {
				    setSensors (data.sensors);
				    setReady (true);
			    }

			});
	}, [i18n.language, parameter]);


	useEffect (() => {
	    (data !== null && sensors !== undefined) && (sensors.length > 0) && draw(data, sensors);
	}, [i18n.language, resize, sensors]);

	/* Toggle Button*/
	const handleClick = (index) => () => {
		let s = sensors[index];
		s.active = !s.active;
		setSensors ([...sensors]);
	};

	return (
		<>
	    {ready &&
		<>
		<Box sx={{ flexGrow: 1, padding: '10px' }}>
		<Grid container spacing={0}>
		
		<Grid item container xs={12} sx={{ justifyContent: 'space-between' }}>
		    <Typography variant="h6">
			{t("temperature")}
		    </Typography>
		</Grid>
		
		<Grid item xs={12}>

    
			<div className="flex-row">
				{sensors !== undefined &&
					sensors.map ((sensor, index) =>
					{
						return (
							<SensorButton key={index} sensor={sensor} svgref="tempchart" index={index} callback={handleClick(index)} /> 
						)
					})
				}
			</div>

			<div id="svgchart">
				<svg ref={svgRef} id="tempchart" className="d3chart"></svg>
			</div>
		<GraphicButton object={"tempchart"} filename={t("temperature")}/>
		</Grid>
		
		</Grid>
		</Box>
		</>
		}
		</>
	);
}
